// ProcessComponent.js
import React, { Component } from 'react';
import { Input, Dropdown, Button, Grid, Feed, Checkbox,Popup } from 'semantic-ui-react';
import moment from 'moment';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import ImageAvater from '../../../../components/drive/Components/ImageAvater';
import ShowScenarioInputs from "../drive/modals/ShowScenarioInputs";
import ShowFieldMappingScenarioInputs from "../drive/modals/ShowFieldMappingScenarioInputs";
import momentDateAndTime from '../../../../helpers/momentDateAndTime'
let events = require("../../../../helpers/events.json");
let FieldMap = require('../../../../images/common/field-mapping-icon.svg');

class ProcessComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProcessEventValue: '',
      selectedProcessTemplate: '',
      scenarioInputs: [],
      selectedProcessScenario: '',
      selectedProcessEvent: '',
      scenarioInputsModalFlag: false,
      scenarioFieldMappingInputsModalFlag: false,
      selectedActivityAction: {},
      selectedScenarioInputs: [],
      selectedScenarioInput: {},
      fetchingInProgress: false,
      fetchingInputScenariosInProgress: false,
      dummyFlag: false,
      inputErrors: {}
    };
  }
  componentWillMount() {
    this.checkMakeIntegration();
    dispatch.lifeCycle.getEntityFieldMapping();
  }

  // Methods for event/template changes can go here
  updatedProcessEvent = async (e, value, context) => {
    this.setState({fetchingInProgress: true});
    // Update state when event changes
    let selectedEvent = value.options.find((option)=>option.value==value.value)
    this.setState({ selectedProcessEvent: selectedEvent });
    this.setState({ selectedProcessEventValue: value.value });
    if (value.value == 1) {
        this.setState({ selectedProcessScenario: "" });
        await dispatch.lifeCycle.fetchCustomTemplates({
            ...this.props.selectedPracticeFlowActivity,
            processingType: this.props.processingType
        }, this.props.activityActions);
    } else if (value.value == 2) {
        this.setState({ selectedProcessTemplate: "" });
        await dispatch.lifeCycle.setScenarioInputs([]);
        await dispatch.lifeCycle.fetchMakeScenarios(this.props);
    }
    this.setState({fetchingInProgress: false});
  };

  updatedProcessTemplate = (e, value) => {
    // Update template selection
    this.setState({ selectedProcessTemplate: value.value });
  };

  updatedProcessScenario = async (e, value) => {
    this.setState({fetchingInputScenariosInProgress: true});
    await this.setState({ selectedProcessScenario: value.value });
    let payload = {
        "scenarioId": this.state.selectedProcessScenario
    }
    await dispatch.lifeCycle.fetchScenarioInputs(payload);
    this.setState({fetchingInputScenariosInProgress: false});
  }

  onChangeValue = (event, input) => {
    const newValue = event.target.value;
    const updatedScenarioInputs = this.state.scenarioInputs.map((scenarioInput) => {
      if (scenarioInput.name === input.name) {
        scenarioInput.default = newValue;
      }
      return scenarioInput;
    });
    const updatedErrors = { ...this.state.inputErrors };
    if (newValue) {
      delete updatedErrors[input.name];
    }
    this.setState({ 
      scenarioInputs: updatedScenarioInputs,
      inputErrors: updatedErrors 
    });
  };

  DeleteScenario = async(action)=>{
    if(action.actionId==="1"){
        let message = <div className="confirmMessage">
                        <h3>Delete Template</h3>
                        <p>Are you sure that you wish to delete template?</p>
                        <span>This action is not reversible</span>
                      </div>
        toastr.confirm(message, {
            onOk: () => {
                dispatch.lifeCycle.deleteActivityActions(action);
            }
        });
        this.setState({ selectedProcessEvent: "" });
        this.setState({ selectedProcessTemplate: "" });
        this.setState({ selectedProcessEventValue: "" });
    } else if(action.actionId==="2"){
        let message = <div className="confirmMessage">
                        <h3>Delete Scenario</h3>
                        <p>Are you sure that you wish to delete scenario?</p>
                        <span>This action is not reversible</span>
                      </div>
        toastr.confirm(message, {
            onOk:async () => {
                dispatch.lifeCycle.deleteActivityActions(action);
                await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(this.props.selectedPracticeLibrary._id);
            }
        });
        this.setState({ selectedProcessEvent: "" });
        this.setState({ selectedProcessScenario: "" });
        this.setState({ selectedProcessEventValue: "" });
    }
  }
  manageScenarioInputModal = (modalFlag) => {
    this.setState({scenarioInputsModalFlag: modalFlag})
  }

  manageFieldMappingScenarioInputModal = (modalFlag) => {
    this.setState({scenarioFieldMappingInputsModalFlag: modalFlag})
  }

  openModal = (action) => {
    this.setState({selectedActivityAction: action});
    if(action && action.metaData && action.metaData.scenarioInputs){
      this.setState({selectedScenarioInputs: action.metaData.scenarioInputs});
    }
    this.manageScenarioInputModal(true); // Open modal
  }

  closeModal = () => {
    this.manageScenarioInputModal(false); // Close modal
    this.setState({selectedActivityAction: {}});
    this.setState({selectedScenarioInputs: []});
  }

  openFieldMappingModal = (input) => {
    this.setState({selectedScenarioInput: input});
    this.manageFieldMappingScenarioInputModal(true); // Open modal
  }

  closeFieldMappingModal = () => {
    // Clear error for the field if it has been mapped
    const input = this.state.selectedScenarioInput;
    if (input && input.query) {
        const updatedErrors = { ...this.state.inputErrors };
        delete updatedErrors[input.name];
        this.setState({ inputErrors: updatedErrors });
    }
    this.manageFieldMappingScenarioInputModal(false); // Close modal
  }

  setProcessingData = async() => {
    if (this.state.selectedProcessEventValue === 2) {
      const errors = {};
      this.state.scenarioInputs.forEach(input => {
        if (input.required) {
          if (!input.checked && !input.default) {
            // Field is required and neither mapped nor has a default value
            errors[input.name] = 'This field is required';
          } else if (input.checked && !input.query) {
            // Field is required, toggle is on, but no mapping is set
            errors[input.name] = 'Field mapping is required';
          }
        }
      });

      if (Object.keys(errors).length > 0) {
        this.setState({ inputErrors: errors });
        return;
      }
    }

    if(this.state.selectedProcessEvent && this.state.selectedProcessEvent.id && this.state.selectedProcessTemplate && this.state.selectedProcessEventValue==1){  
      let data = {
            "actionId": this.state.selectedProcessEvent.id,
            "name": this.state.selectedProcessEvent.text,
            "type": this.state.selectedProcessEvent.type,
            "status": 0,
            "processingType": this.props.processingType,
            "metaData": {"templateId": this.state.selectedProcessTemplate},
            "accountId": this.props.selectedAccount._id,
            "organizationId": this.props.selectedOrganisation.id,
            "playbookId": this.props.selectedPracticeLibrary._id,
            "activityId": this.props.selectedPracticeFlowActivity._id,
            "createdBy": this.props.user._id,
            "lastUpdatedBy": this.props.user._id
        }
        await dispatch.lifeCycle.configureActivityActions(data)
        this.setState({ selectedProcessEvent: "" });
        this.setState({ selectedProcessTemplate: "" });
        this.setState({ selectedProcessEventValue: "" });

    } else if(this.state.selectedProcessEvent && this.state.selectedProcessEvent.id && this.state.selectedProcessScenario && this.state.selectedProcessEventValue==2) {
        let data = {
            "actionId": this.state.selectedProcessEvent.id,
            "name": this.state.selectedProcessEvent.text,
            "type": this.state.selectedProcessEvent.type,
            "status": 0,
            "processingType": this.props.processingType,
            "metaData": {
                "scenarioId": this.state.selectedProcessScenario,
                "scenarioInputs": this.state.scenarioInputs
            },
            "accountId": this.props.selectedAccount._id,
            "organizationId": this.props.selectedOrganisation.id,
            "playbookId": this.props.selectedPracticeLibrary._id,
            "activityId": this.props.selectedPracticeFlowActivity._id,
            "createdBy": this.props.user._id,
            "lastUpdatedBy": this.props.user._id
        }
        await dispatch.lifeCycle.configureActivityActions(data);
        await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(this.props.selectedPracticeLibrary._id);
        this.setState({ selectedProcessEvent: "" });
        this.setState({ selectedProcessScenario: "" });
        this.setState({ selectedProcessEventValue: "" });
    }
  }
  checkMakeIntegration = async () => {
    events = require("../../../../helpers/events.json");
    let selectedOrganization = this.props.selectedOrganisation;
    if (selectedOrganization && selectedOrganization.integrations && selectedOrganization.integrations.length > 0) {
      const makeIntegrationExists = selectedOrganization.integrations.find((integration) => integration.type == "make");
      if (!makeIntegrationExists || !makeIntegrationExists.type) {
        events = events.filter(event => event.type !== "make");
      }
    } else {
      events = events.filter(event => event.type !== "make");
    }
  }
  enableFieldMapping = async (e, field) => {
    this.state.scenarioInputs.map((input, index)=>{
      if(input.name == field.name){
        input.checked = !input.checked;
        if(!input.checked){
          delete input.query;
          delete input.collection;
          // Clear error when toggle is turned off
          const updatedErrors = { ...this.state.inputErrors };
          delete updatedErrors[input.name];
          this.setState({ inputErrors: updatedErrors });
        }
      }
    });
    this.setState({dummyFlag: !this.state.dummyFlag});
  }

     isAuthor = () => {
        if (this.props.isAuthor) {
            return true;
        }
        else {
            return false;
        }
    }

    isWorkspaceOwner = () => {
        if (this.props.isWorkspaceOwner) {
            return true;
        }
        else {
            return false;
        }
    }

    isContributor = () => {
        if (this.props.isContributor) {
            return true;
        }
        else {
            return false;
        }
    }
  render() {
    let role = this.props.selectedOrganisation && this.props.selectedOrganisation.role;
    const { customEmailTemplates, activityActions, user, processingType } = this.props;
    this.state.scenarioInputs = this.props.scenarioInputs;
    let checkAllValuesSelected = (this.state.selectedProcessEventValue && (this.state.selectedProcessTemplate || this.state.selectedProcessScenario) && !this.state.fetchingInputScenariosInProgress) ? true : false;
    return (
      <div>
        <div tabTitle={<div>{processingType}</div>}></div>
        <div className="acc-header">{processingType}
        {/* {(this.props.status === 0 || this.isAuthor) && (
          <span style={{ margin: "0 20px" }} className="clr-gray fs_italic">
            <Button
                disabled={!checkAllValuesSelected}
                content="Save"
                className="button-submit float-right"
                type="button"
                onClick={() => this.setProcessingData()}
            />
          </span>
        )} */}
        {(this.props.selectedPracticeLibrary.status === 0 || (this.isAuthor() || this.isContributor() || this.isWorkspaceOwner()) ) && (
          <span style={{ margin: "0 20px" }} className="clr-gray fs_italic">
            <Button
              disabled={!checkAllValuesSelected}
              content="Save"
              className="button-submit float-right"
              type="button"
              onClick={() => this.setProcessingData()}
            />
          </span>
        )}
        </div>
        <Grid.Row className="pad_tb_4">
          <Grid.Column width={7}>
            <label>Events</label>
            
            {(this.props.selectedPracticeLibrary.status === 0 || (this.isAuthor() || this.isContributor() || this.isWorkspaceOwner())) && (
              <Dropdown
                required
                name="default"
                selection
                fluid
                options={events}
                value={this.state.selectedProcessEventValue}
                placeholder="Select Event"
                upward={false}
                onChange={(e, value) => this.updatedProcessEvent(e, value)}
              />
            )}
            
            {this.state.selectedProcessEventValue === 1 && (
              <div>
                <div style={{ marginTop: '5px' }}>
                  <label>Templates</label>
                  <Dropdown required name="default" selection fluid options={customEmailTemplates}
                    value={this.state.selectedProcessTemplate} placeholder="Select Template" upward={false} onChange={(e,
                    value)=> this.updatedProcessTemplate(e, value)}
                    />
                </div>
                <div style={{ marginTop: '8px' }}>{(!this.state.fetchingInProgress && (!customEmailTemplates || customEmailTemplates.length==0)) ?
                  <span className='clr-orange'>No template to select</span>:""}</div>
              </div>
            )}
            {this.state.selectedProcessEventValue === 2 && (
              <div style={{ marginTop: '5px' }}>
                <label>Scenarios</label>
                <Dropdown
                  required
                  name="default"
                  selection
                  fluid
                  options={this.props.scenarios}
                  value={this.state.selectedProcessScenario}
                  placeholder="Select Scenario"
                  upward={false}
                  onChange={(e, value) => this.updatedProcessScenario(e, value)}
                />
                <div style={{ marginTop: '8px' }}>{(!this.state.fetchingInProgress && (!this.props.scenarios || this.props.scenarios.length==0)) ? <span className='clr-orange'>No scenario to select</span>:""}</div>
                {this.props.scenarioInputs && this.props.scenarioInputs.length > 0 && (
                  <div style={{ overflowX: 'auto' }}>
                    <Grid style={{ marginTop: '10px', minWidth: '500px' }} columns={3}>
                      <Grid.Row>
                        <Grid.Column width={6} style={{ textAlign: "center"}}>
                          <div className='acc-header'>Field</div>
                        </Grid.Column>
                        <Grid.Column width={3} style={{ textAlign: "center" }}>
                          <div className='acc-header'>Map field</div>
                        </Grid.Column>
                        <Grid.Column width={7} style={{ textAlign: "center" }}>
                          <div className='acc-header'>Value</div>
                        </Grid.Column>
                      </Grid.Row>
                      {this.state.scenarioInputs.map((input, index) => (
                        <Grid.Row key={index} style={{ marginBottom: '0' }}>
                          <Grid.Column width={6}>
                            <Input 
                              style={{ width: "100%", 'pointer-events': 'none' }} 
                              disabled 
                              placeholder="Name" 
                              value={input.name} 
                            />
                          </Grid.Column>
                          <Grid.Column width={3} style={{ textAlign: "center" }}>
                            <Checkbox
                              style={{ marginTop: '5px'}}
                              toggle
                              checked={input.checked}
                              onChange={(e) => this.enableFieldMapping(e, input)}
                            />
                          </Grid.Column>
                          <Grid.Column width={7} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <div style={{ width: '85%' }}>
                              <Input
                                style={{
                                  width: "100%",
                                  border: this.state.inputErrors[input.name] ? '1px solid red' : null,
                                  borderRadius: '4px'
                                }}
                                onChange={(e) => this.onChangeValue(e, input)}
                                placeholder="Value"
                                disabled={input.checked ? true : false}
                                value={input.query ? input.query : (input.checked && !input.query) ? "map value" : input.default}
                                required={input.required}
                              />
                            </div>
                            {input.checked && 
                              <Popup
                                  content="Field Mapping"
                                  className="cursor-pointer popupStyled"
                                  inverted
                                  trigger={
                                    <span className='cursor-pointer' style={{ marginLeft: '5px'}} onClick={() => this.openFieldMappingModal(input)}>
                                      <img 
                                        src={FieldMap}
                                        alt="mapping"
                                        width="16"
                                        height="16"
                                      />
                                    </span>
                                  }
                                  position="top left"
                                  size="tiny"
                                />
                            }
                          </Grid.Column>
                        </Grid.Row>
                      ))}
                    </Grid>
                  </div>
                )}
              </div>
            )}
          </Grid.Column>
        </Grid.Row>
        {activityActions && activityActions.length > 0 ? (
          activityActions.map((action, i) => (
            action.processingType == this.props.processingType ?
            <Feed key={i} className="bg-white pad_5" style={{ padding: 0, margin: "10px 0 0 0", background: "none" }}>
              <Feed.Event>
                <ImageAvater user={action.createdBy} className="clr-white w_24 h_24" imageStyle="clr-white w_24 h_24" />
                <Feed.Content>
                  <Feed.Summary>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ flex: 1 }}>
                        {action.createdBy.firstName} {action.createdBy.lastName} <br />
                        {action.name} <br />
                        {action.templateDetails && action.templateDetails.name ? action.templateDetails.name : ""}
                        {action.metaData && action.metaData.scenarioName ? action.metaData.scenarioName : ""}
                      </div>
                      <span style={{ marginLeft: '10px', textAlign: 'right' }}>
                        {momentDateAndTime(action.createdAt)}
                        <br />
                       {( role === "workspaceOwner" || this.isContributor()) ? (
                          <span>
                            {action.metaData.scenarioId ? <span style={{ marginRight: '8px' }} className="clr-blue text-underline cursor-pointer" onClick={() => this.openModal(action)}>
                              Edit
                            </span> : ""}
                            <span className="clr-blue text-underline cursor-pointer" onClick={() => this.DeleteScenario(action)}>
                              Delete
                            </span>
                          </span>
                        ) : ''}
                      </span>
                    </div>
                  </Feed.Summary>
                </Feed.Content>
              </Feed.Event>
            </Feed>:""
          ))
        ) : ""}
        <ShowScenarioInputs
          open={ this.state.scenarioInputsModalFlag }
          close={ this.closeModal }
          selectedActivityAction = { this.state.selectedActivityAction }
          selectedScenarioInputs = { this.state.selectedScenarioInputs }
          entities = { this.props.entities }
          entityFieldMapping = { this.props.entityFieldMapping }
          organizationId = {this.props.selectedOrganisation.id}
          teamList = {this.props.teamList}
        />
        {this.state.scenarioFieldMappingInputsModalFlag ? <ShowFieldMappingScenarioInputs
          open={ this.state.scenarioFieldMappingInputsModalFlag }
          close={ this.closeFieldMappingModal }
          selectedScenarioInput = { this.state.selectedScenarioInput }
          entities = { this.props.entities }
          entityFieldMapping = { this.props.entityFieldMapping }
          organizationId = {this.props.selectedOrganisation.id}
          teamList = {this.props.teamList}
        />:""}
      </div>
    );
  }
}

export default ProcessComponent;